"use client";

import { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SiteLoader from "./SiteLoader";
import HeroSequence from "./HeroSequence";
import { usePreserveScrollOnResize } from "./_lib/usePreserveScrollOnResize";

const CorePrinciples = dynamic(() => import("./CorePrinciples"));
const AISection = dynamic(() => import("./AISection"));
const TeachersSection = dynamic(() => import("./TeachersSection"));
const TeamSection = dynamic(() => import("./TeamSection"));
const ClosingSection = dynamic(() => import("./ClosingSection"));

export default function HomeClient() {
  const [siteReady, setSiteReady] = useState(false);
  const [loaderDone, setLoaderDone] = useState(false);

  useEffect(() => {
    window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
  }, []);

  usePreserveScrollOnResize();

  useEffect(() => {
    const refresh = () => {
      ScrollTrigger.refresh();
    };

    let lastWidth = window.innerWidth;
    const refreshOnWidthChange = () => {
      const width = window.innerWidth;
      if (width === lastWidth) return;
      lastWidth = width;
      ScrollTrigger.refresh();
    };
    const refreshOnOrientationChange = () => {
      requestAnimationFrame(() => {
        lastWidth = window.innerWidth;
        ScrollTrigger.refresh();
      });
    };

    window.addEventListener("load", refresh);
    window.addEventListener("pageshow", refresh);
    window.addEventListener("resize", refreshOnWidthChange);
    window.addEventListener("orientationchange", refreshOnOrientationChange);

    return () => {
      window.removeEventListener("load", refresh);
      window.removeEventListener("pageshow", refresh);
      window.removeEventListener("resize", refreshOnWidthChange);
      window.removeEventListener("orientationchange", refreshOnOrientationChange);
    };
  }, []);

  useEffect(() => {
    if (!loaderDone) return;

    ScrollTrigger.refresh();
    const raf = requestAnimationFrame(() => ScrollTrigger.refresh());
    const delayed = window.setTimeout(() => ScrollTrigger.refresh(), 400);

    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(delayed);
    };
  }, [loaderDone]);

  return (
    <div className="bg-[#0D004D] min-h-screen">
      <SiteLoader isReady={siteReady} onComplete={() => setLoaderDone(true)} />
      <main id="main">
        <HeroSequence
          onReady={() => setSiteReady(true)}
          loaderDone={loaderDone}
        />
        <AISection />
        <CorePrinciples />
        <TeachersSection />
        <TeamSection />
        <ClosingSection />
      </main>
    </div>
  );
}
